import { LucideIcon, Video, Mail, Presentation, Phone, MessageSquare, Brain, Sparkles, Users, Zap, Share2, Compass } from "lucide-react";

export interface Capsula {
  id: string;
  icon: LucideIcon;
  title: string;
  description: string;
  difficulty: "Fácil" | "Media" | "Avanzada";
  timeToImplement: string;
  relatedPostIds: string[];
  category: string;
  views?: number;
  isManual?: boolean;
  isAutoGenerated?: boolean;
}

export const capsulas: Capsula[] = [
  {
    id: "creacion-videos",
    icon: Video,
    title: "Creación de Videos con IA",
    description: "Crea videos profesionales desde tu ordenador. No necesitas cámara, ni equipo caro, ni saber editar. Solo tu voz y estas herramientas.",
    difficulty: "Fácil",
    timeToImplement: "15 minutos",
    relatedPostIds: ["17", "11", "8", "44", "64", "65"],
    category: "Contenido Visual",
    views: 1240
  },
  {
    id: "automatizacion-emails",
    icon: Mail,
    title: "Automatizaciones",
    description: "Deja que la IA responda emails, procese facturas y gestione consultas mientras duermes. Recupera hasta 15 horas cada semana.",
    difficulty: "Media",
    timeToImplement: "30 minutos",
    relatedPostIds: ["25", "23", "16", "15", "9", "35", "36", "43", "45", "49", "51", "57", "59", "60", "61", "67", "52", "37", "39"],
    category: "Automatización",
    views: 980
  },
  {
    id: "creacion-presentaciones",
    icon: Presentation,
    title: "Presentaciones con IA",
    description: "Escribe una frase y obtén una presentación completa en minutos. PowerPoint y Google Vids lo hacen por ti.",
    difficulty: "Fácil",
    timeToImplement: "10 minutos",
    relatedPostIds: ["6", "19", "20", "68"],
    category: "Presentaciones",
    views: 720
  },
  {
    id: "agentes-voz",
    icon: Phone,
    title: "Agentes de Voz Inteligentes",
    description: "Un asistente que atiende llamadas mientras tú trabajas. Toma pedidos, responde dudas y da soporte 24/7.",
    difficulty: "Media",
    timeToImplement: "45 minutos",
    relatedPostIds: ["4", "33", "32"],
    category: "Atención al Cliente",
    views: 650
  },
  {
    id: "analisis-documentos",
    icon: Brain,
    title: "Análisis y Consultas IA",
    description: "Sube tus documentos y pregunta lo que necesites. La IA encuentra la información al instante, sin buscar horas.",
    difficulty: "Fácil",
    timeToImplement: "20 minutos",
    relatedPostIds: ["18", "24", "34", "50", "56", "53", "48", "38", "55", "54"],
    category: "Productividad",
    views: 580
  },
  {
    id: "redes-sociales",
    icon: Share2,
    title: "Contenido para Redes Sociales",
    description: "Investiga, crea y programa contenido para LinkedIn, Instagram y otras redes. La IA mantiene tu estilo personal.",
    difficulty: "Fácil",
    timeToImplement: "20 minutos",
    relatedPostIds: ["13", "7", "14", "2", "21", "26", "44", "63", "28"],
    category: "Redes Sociales",
    views: 420
  },
  {
    id: "herramientas-desarrollo",
    icon: Zap,
    title: "Herramientas para Desarrolladores",
    description: "Si tienes un informático en el equipo, estas herramientas multiplican lo que puede hacer en un día.",
    difficulty: "Avanzada",
    timeToImplement: "1 hora",
    relatedPostIds: ["12", "10", "27", "58", "62", "66", "40", "30", "22"],
    category: "Desarrollo",
    views: 290
  },
  {
    id: "estrategia-ia",
    icon: Compass,
    title: "¿Está tu empresa lista para la IA?",
    description: "Antes de automatizar, diagnostica. Descubre en qué etapa está tu negocio y qué implementar primero para no tirar el dinero.",
    difficulty: "Fácil",
    timeToImplement: "15 minutos",
    relatedPostIds: ["31", "41", "47"],
    category: "Estrategia IA",
    views: 350
  }
];
